import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["id", "classes", "fields", "beforeChange", "margin", "placeholder", "inputProps", "InputProps", "inputPlaceholder", "InputLabelProps", "meta", "helperText", "searchValue", "loadOptions", "debounceInterval", "components", "loadOptionsTotal", "intl", "noneDefaultPlaceholder", "changeKey", "maxSelected"];
var _dec, _class, _class2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/prop-types */

import debounce from 'debounce-promise';
import React from 'react';
import _ from 'lodash';
// import PropTypes from 'prop-types';
// import { fieldInputPropTypes } from 'redux-form';
import withMuiStyles from '@mui/styles/withStyles';
import AsyncSelect /* , { Props } */ from 'react-select/async';
// import { ValueType } from 'react-select/src/types';
// import { SelectComponentsConfig } from 'react-select/src/components/index';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { styles, Option, DropdownIndicator, Control, ValueContainer, SingleValue, MultiValue, NoOptionsMessage, Placeholder, Menu } from '../Autocomplete/Autocomplete';
export var messages = defineMessages({
  defaultTotalInputPlaceholder: {
    id: "AsyncAutocomplete.defaultTotalInputPlaceholder",
    defaultMessage: [{
      "type": 0,
      "value": "Start typing to find "
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "... ("
    }, {
      "type": 1,
      "value": "total"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "`s)"
    }]
  },
  noResultFound: {
    id: "AsyncAutocomplete.noResultFound",
    defaultMessage: [{
      "type": 0,
      "value": "No results found"
    }]
  },
  selectLabel: {
    id: "AsyncAutocomplete.selectLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Select ..."
    }]
  },
  itemsLabel: {
    id: "AsyncAutocomplete.itemsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "("
    }, {
      "type": 1,
      "value": "items"
    }, {
      "type": 0,
      "value": " items)"
    }]
  },
  startTypingNameHere: {
    id: "AsyncAutocomplete.startTypingNameHere",
    defaultMessage: [{
      "type": 0,
      "value": "Start typing name here..."
    }]
  },
  loading: {
    id: "AsyncAutocomplete.loading",
    defaultMessage: [{
      "type": 0,
      "value": "Loading..."
    }]
  }
});

// export {
//   primaryAutocompleteStyles, // tableFilterAutocompleteStyles,
// } from '../Autocomplete/Autocomplete';

var noOptionsMessage = function noOptionsMessage() {
  return /*#__PURE__*/React.createElement(FormattedMessage, messages.noResultFound);
};
var AsyncAutocompleteArray = (_dec = withMuiStyles(styles), _dec(_class = injectIntl(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(AsyncAutocompleteArray, _React$Component);
  var _super = _createSuper(AsyncAutocompleteArray);
  // static propTypes = {
  //   changeSearchField: PropTypes.func,
  //   margin: PropTypes.oneOf('none', 'normal'),
  //   placeholder: PropTypes.oneOfType(PropTypes.node, PropTypes.string),
  //   inputPlaceholder: PropTypes.oneOfType(PropTypes.node, PropTypes.string),
  //   styles: PropTypes.shape({}),
  //   components: PropTypes.shape({}),
  //   value: PropTypes.shape({}),
  //   // components: SelectComponentsConfig,
  //   // ...Props,
  //   ...StyledComponentProps,
  //   ...fieldInputPropTypes,
  // };

  // static defaultProps = {
  //   changeSearchField: () => null,
  //   value: null,
  //   margin: 'none',
  //   placeholder: <FormattedMessage {...messages.selectLabel} />,
  //   inputPlaceholder: '',
  //   styles: {},
  //   components: {},
  // };

  function AsyncAutocompleteArray(props) {
    var _this;
    _classCallCheck(this, AsyncAutocompleteArray);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      if (!value && _this.props.searchValue) {
        _this.loadOptionsDebounced('');
      }
      if (_this.props.changeSearchField) {
        _this.props.changeSearchField(value);
      }
      return value;
    });
    var _props$loadOptions = props.loadOptions,
      loadOptions = _props$loadOptions === void 0 ? function () {
        return null;
      } : _props$loadOptions,
      debounceInterval = props.debounceInterval;
    if (!debounceInterval) {
      _this.loadOptionsDebounced = loadOptions;
      return _possibleConstructorReturn(_this);
    }
    _this.loadOptionsDebounced = debounce(loadOptions, debounceInterval);
    return _this;
  }
  _createClass(AsyncAutocompleteArray, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.fields.length && this.props.fields.length) {
        nextProps.loadOptions('');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        _this$props$classes = _this$props.classes,
        classes = _this$props$classes === void 0 ? {} : _this$props$classes,
        fields = _this$props.fields,
        beforeChange = _this$props.beforeChange,
        _this$props$margin = _this$props.margin,
        margin = _this$props$margin === void 0 ? 'none' : _this$props$margin,
        _this$props$placehold = _this$props.placeholder,
        placeholder = _this$props$placehold === void 0 ? /*#__PURE__*/React.createElement(FormattedMessage, messages.selectLabel) : _this$props$placehold,
        _this$props$inputProp = _this$props.inputProps,
        inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
        _this$props$InputProp = _this$props.InputProps,
        InputProps = _this$props$InputProp === void 0 ? {} : _this$props$InputProp,
        _this$props$inputPlac = _this$props.inputPlaceholder,
        inputPlaceholder = _this$props$inputPlac === void 0 ? '' : _this$props$inputPlac,
        _this$props$InputLabe = _this$props.InputLabelProps,
        InputLabelProps = _this$props$InputLabe === void 0 ? {} : _this$props$InputLabe,
        _this$props$meta = _this$props.meta,
        error = _this$props$meta.error,
        touched = _this$props$meta.touched,
        submitFailed = _this$props$meta.submitFailed,
        _this$props$helperTex = _this$props.helperText,
        helperText = _this$props$helperTex === void 0 ? '' : _this$props$helperTex,
        _this$props$searchVal = _this$props.searchValue,
        searchValue = _this$props$searchVal === void 0 ? '' : _this$props$searchVal,
        _this$props$loadOptio = _this$props.loadOptions,
        loadOptions = _this$props$loadOptio === void 0 ? function () {
          return null;
        } : _this$props$loadOptio,
        debounceInterval = _this$props.debounceInterval,
        _this$props$component = _this$props.components,
        components = _this$props$component === void 0 ? {} : _this$props$component,
        _this$props$loadOptio2 = _this$props.loadOptionsTotal,
        loadOptionsTotal = _this$props$loadOptio2 === void 0 ? 0 : _this$props$loadOptio2,
        formatMessage = _this$props.intl.formatMessage,
        _this$props$noneDefau = _this$props.noneDefaultPlaceholder,
        noneDefaultPlaceholder = _this$props$noneDefau === void 0 ? false : _this$props$noneDefau,
        changeKey = _this$props.changeKey,
        maxSelected = _this$props.maxSelected,
        other = _objectWithoutProperties(_this$props, _excluded);
      var placeholderVal = inputPlaceholder;
      if (!noneDefaultPlaceholder) {
        var defaultPlaceholder = inputPlaceholder || formatMessage(messages.startTypingNameHere);
        placeholderVal = "".concat(defaultPlaceholder, " ").concat(formatMessage(messages.itemsLabel, {
          items: loadOptionsTotal
        }));
      }

      // It's huck in order to fix https://app.asana.com/0/1205168629240507/1202546495608266/f
      // (validation is not triggered after update of key, but without updating of key, loadOptions is not triggered and options are not updated after removing of some value)
      var keyProp = changeKey ? {
        key: changeKey
      } : {};
      return /*#__PURE__*/_jsx("div", {
        className: classes.root
      }, void 0, /*#__PURE__*/React.createElement(AsyncSelect, _extends({
        loadOptions: this.loadOptionsDebounced,
        classes: classes,
        placeholder: placeholderVal,
        inputValue: searchValue,
        onInputChange: this.onInputChange,
        noOptionsMessage: noOptionsMessage
        // ref={asyncRef}
        ,
        value: fields.getAll(),
        isOptionDisabled: function isOptionDisabled() {
          var _this2$props = _this2.props,
            maxSelected = _this2$props.maxSelected,
            fields = _this2$props.fields;
          var values = fields.getAll() || [];
          return maxSelected && values.length >= maxSelected;
        },
        onChange: function onChange(value, event) {
          var _this2$props2 = _this2.props,
            maxSelected = _this2$props2.maxSelected,
            fields = _this2$props2.fields;
          var currentValues = fields.getAll() || [];
          switch (event.action) {
            case 'select-option':
              if (!maxSelected || currentValues.length < maxSelected) {
                fields.push(event.option);
              }
              break;
            case 'remove-value':
              fields.remove(_.indexOf(fields.getAll(), event.removedValue));
              break;
            case 'pop-value':
              fields.pop();
              break;
            case 'clear':
              fields.removeAll();
              break;
            default:
              break;
          }
        },
        textFieldProps: {
          label: placeholder,
          helperText: (touched || submitFailed) && error || helperText,
          error: !!((touched || submitFailed) && error),
          InputLabelProps: _objectSpread({
            shrink: true
          }, InputLabelProps),
          margin: margin
        },
        InputProps: _objectSpread({
          id: id
        }, InputProps),
        inputProps: inputProps,
        maxMenuHeight: 250,
        components: _objectSpread({
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          },
          Option: Option,
          Control: Control,
          NoOptionsMessage: NoOptionsMessage,
          Placeholder: Placeholder,
          SingleValue: SingleValue,
          MultiValue: MultiValue,
          ValueContainer: ValueContainer,
          Menu: Menu
        }, components),
        styles: _objectSpread({
          input: function input(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              color: '#fff'
            });
          },
          menu: function menu(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              borderRadius: 0
            });
          },
          placeholder: function placeholder(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              color: '#fff'
            });
          },
          singleValue: function singleValue(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              color: '#fff'
            });
          },
          valueContainer: function valueContainer(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              color: '#fff'
            });
          }
        }, this.props.styles),
        loadingMessage: function loadingMessage() {
          return formatMessage(messages.loading);
        },
        margin: true
      }, keyProp, other)));
    }
  }]);
  return AsyncAutocompleteArray;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  debounceInterval: 300
}), _class2)) || _class) || _class);
export { AsyncAutocompleteArray as default };